import { toUrlBase64 } from '../common/functions';
var CookieTokenAuthenticationFactors = (function () {
    function CookieTokenAuthenticationFactors(token) {
        var tokenBase64Url = toUrlBase64(token);
        var middle = Math.ceil(tokenBase64Url.length / 2);
        this.firstFactor = tokenBase64Url.substring(0, middle);
        this.secondFactor = tokenBase64Url.substring(middle);
    }
    CookieTokenAuthenticationFactors.prototype.getFirstFactor = function () {
        return this.firstFactor;
    };
    CookieTokenAuthenticationFactors.prototype.getSecondFactor = function () {
        return this.secondFactor;
    };
    return CookieTokenAuthenticationFactors;
}());
export { CookieTokenAuthenticationFactors };
//# sourceMappingURL=CookieTokenAuthenticationFactors.js.map